import { CheckCircle, Clock, X } from 'lucide-react';
import { useSubscription } from '../contexts/SubscriptionContext';

export function PaymentNotice() {
  const { payment, clearPayment, setShowPaywall } = useSubscription();
  if (!payment) return null;
  const approved = payment.status === 'approved';
  const rejected = payment.status === 'rejected';
  return (
    <div data-testid="payment-status-notice" role="status" className="relative z-10 shrink-0 flex items-center gap-2 px-4 py-2 bg-white border-b border-[#FFE0E8] text-xs text-[#6B4C55]">
      {approved ? <CheckCircle size={16} className="shrink-0 text-green-600" /> : <Clock size={16} className="shrink-0 text-[#F4436C]" />}
      <span className="flex-1" data-testid="payment-status-text">{approved ? 'Payment approved. Premium is active!' : rejected ? 'Payment could not be verified.' : payment.status === 'pending' ? 'Payment verification pending' : 'Your payment is unfinished'}</span>
      {!approved && <button data-testid="payment-view-details" onClick={() => setShowPaywall(true)} className="font-bold text-[#AB3657] underline">View</button>}
      {(approved || rejected) && <button data-testid="payment-dismiss-notice" aria-label="Dismiss payment notice" onClick={clearPayment}><X size={16} /></button>}
    </div>
  );
}